import type {
  BehaviourImpl,
  BehaviourInitArgs,
  BehaviourRuntime,
} from "./types.js";

const REGISTRY = new Map<string, BehaviourImpl<unknown>>();

export function registerBehaviour<T>(impl: BehaviourImpl<T>): void {
  REGISTRY.set(impl.name, impl as unknown as BehaviourImpl<unknown>);
}

export function getBehaviour(name: string): BehaviourImpl<unknown> | undefined {
  return REGISTRY.get(name);
}

export function listBehaviours(): readonly string[] {
  return [...REGISTRY.keys()];
}

export function clearBehaviours(): void {
  REGISTRY.clear();
}

/**
 * Resolve a behaviour by name and instantiate it. Throws if the name is not
 * in the registry — scenarios are validated at load and an unknown name here
 * indicates a missing register-on-startup, never user error at runtime.
 */
export function instantiateBehaviour(
  name: string,
  args: BehaviourInitArgs<unknown>,
): BehaviourRuntime {
  const impl = REGISTRY.get(name);
  if (impl === undefined) {
    throw new Error(
      `Unknown behaviour: ${name}. Known: ${[...REGISTRY.keys()].join(", ") || "(none)"}`,
    );
  }
  return impl.init(args);
}
